import type { RouteRecordRaw } from 'vue-router';

export const EXPECTED_ROUTER: RouteRecordRaw[] = [
  {
    path: '/order/expected',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/order/expected/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/order/expected/views/List.vue'),
        name: 'Expected List',
        meta: {
          title: '입고예정 관리',
        },
      },
    ],
  },
];
